import { Agent } from '../types/Agent';
import { ContactFormValues } from '../components/ContactForm';

// Forcer l'URL de production
const API_BASE_URL = 'https://famber-backend.onrender.com/api';
console.log('API_BASE_URL configuré:', API_BASE_URL);

const defaultHeaders = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};

export const api = {
  // Récupérer tous les agents
  getAllAgents: async (): Promise<Agent[]> => {
    console.log('Tentative de récupération des agents depuis:', `${API_BASE_URL}/agents`);
    try {
      const response = await fetch(`${API_BASE_URL}/agents`, {
        method: 'GET',
        headers: defaultHeaders,
        credentials: 'include'
      });
      
      console.log('Réponse reçue:', response.status);
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }
      return response.json();
    } catch (error) {
      console.error('Erreur détaillée:', error);
      throw error;
    }
  },

   // Récupérer un agent par son ID
   getAgentById: async (id: string): Promise<Agent> => {
    const response = await fetch(`${API_BASE_URL}/agents/${id}`, {
      method: 'GET',
      headers: defaultHeaders,
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Agent non trouvé');
    }
    return response.json();
  },

  // Rechercher des agents
  searchAgents: async (query: string): Promise<Agent[]> => {
    const response = await fetch(`${API_BASE_URL}/agents/search`, {
      method: 'POST',
      headers: defaultHeaders,
      credentials: 'include',
      body: JSON.stringify({ query }),
    });
    if (!response.ok) {
      throw new Error('Erreur lors de la recherche des agents');
    }
    return response.json();
  },

  // Tester un agent
  testAgent: async (id: string, data: ContactFormValues): Promise<void> => {
    const response = await fetch(`${API_BASE_URL}/agents/${id}/test`, {
      method: 'POST',
      headers: defaultHeaders,
      credentials: 'include',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error('Erreur lors du test de l\'agent');
    }
  },

  // Recruter un agent
  hireAgent: async (id: string, data: ContactFormValues): Promise<void> => {
    const response = await fetch(`${API_BASE_URL}/agents/${id}/hire`, {
      method: 'POST',
      headers: defaultHeaders,
      credentials: 'include',
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error('Erreur lors du recrutement de l\'agent');
    }
  },

  // Récupérer l'historique des emails
  getEmailHistory: async () => {
    const response = await fetch(`${API_BASE_URL}/emails/history`, {
      method: 'GET',
      headers: defaultHeaders,
      credentials: 'include'
    });
    if (!response.ok) {
      throw new Error('Erreur lors de la récupération de l\'historique des emails');
    }
    return response.json();
  },
}; 